import {useQuery} from '@tanstack/react-query'
import {sanityClient} from '@/lib/sanity'
import {ALL_POSTS_QUERY} from '@/lib/sanityQueries'
import type {BlogPostSummary} from '@/types/blog'

export const useBlogPosts = () =>
  useQuery({
    queryKey: ['blog', 'posts'],
    queryFn: () => sanityClient.fetch<BlogPostSummary[]>(ALL_POSTS_QUERY),
  })
